import EmployeeAddPage from './add'
export default EmployeeAddPage
